import Regist from './Regist';

export default Regist
export { Regist as Base }
